var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M21.26 10.63c0 5.87-4.76 10.63-10.63 10.63C4.76 21.26 0 16.5 0 10.63 0 4.76 4.76 0 10.63 0c5.87 0 10.63 4.76 10.63 10.63",
    transform: "translate(.857 .025)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M8.114 7.915c0 .98-.795 1.774-1.775 1.774-.98 0-1.775-.794-1.775-1.774S5.36 6.14 6.34 6.14c.98 0 1.775.794 1.775 1.775M16.696 7.915c0 .98-.795 1.774-1.775 1.774-.98 0-1.775-.794-1.775-1.774S13.94 6.14 14.92 6.14c.98 0 1.775.794 1.775 1.775M21.26 10.63c0 5.87-4.76 10.63-10.63 10.63C4.76 21.26 0 16.5 0 10.63h21.26z",
    transform: "translate(.857 .025)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorona);
export default __webpack_public_path__ + "static/media/corona.ad182e1d337af70b9ee17dd52e985c81.svg";
export { ForwardRef as ReactComponent };